var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"border-bottom":"1px solid #ddd","padding":"10px"},on:{"click":function($event){return _vm.$emit('showCitation', _vm.data)}}},[_vm._v(" \n    Citations\n")])}
var staticRenderFns = []

export { render, staticRenderFns }